var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex flex-row items-center justify-center p-2 text-white font-bold gap-2 bg-gray-600 hover:bg-gray-400 rounded-md",attrs:{"href":"https://x.com/nguyen_bing","target":"_blank","rel":"noopener noreferrer","aria-label":"Follow Us on Twitter"}},[_c('i',{staticClass:"bi bi-twitter-x text-xl"}),_vm._v(" Follow Us on Twitter\n")])
}]

export { render, staticRenderFns }